import React, { useState } from 'react';
import { FaPlus, FaCheck, FaTrash } from 'react-icons/fa';
import { createService } from '../../../services/service';
import { useToast } from '../../../hooks/useToast';
import { getUserData } from '../../../Utils/localStorageUtils';
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";


const AddServiceForm = () => {

  const { showSuccess, showError } = useToast()


  const [loading, setLoading] = useState(false); // Loading state for API call

  const [formData, setFormData] = useState({
    name: '',
    location: '',
    email: '',
    mobile: '',
    experience: '',
    companyProfile: '',
    selectedService: '',
    selectedSubServices: [],
    logoImage: null, // Stores the uploaded logo image
    serviceImages: [], // Stores multiple uploaded images
  });


  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
    requestOptions: {
      componentRestrictions: { country: "IN" }, // India ke andar restrict karne ke liye
    },
  });


  const handleLocationSelect = async (address) => {
    setValue(address, false);
    setFormData((prevState) => ({ ...prevState, location: address }));
    clearSuggestions();

    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      setFormData((prevState) => ({ ...prevState, latitude: lat, longitude: lng }));
    } catch (error) {
      console.error("Error getting geocode: ", error);
    }
  };


  const servicesList = [
    'Interior Designer',
    'Vastu Facilities',
    'Home Services',
    'Movers & Packers',
    'Legal Team',
    'Modular Kitchens',
    'Construction Companies',
    'Furniture',
  ];

  const subServicesList = [
    'Plumbing',
    'Electrician',
    'Cleaning Services',
    'Pest Control',
    'Carpenter',
    'Device Servicing (AC, Fridge, etc.)',
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubServiceToggle = (subService) => {
    setFormData((prevState) => {
      const isSelected = prevState.selectedSubServices.includes(subService);
      return {
        ...prevState,
        selectedSubServices: isSelected
          ? prevState.selectedSubServices.filter((item) => item !== subService)
          : [...prevState.selectedSubServices, subService],
      };
    });
  };


  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        logoImage: file,
      }));
    }
  };

  const handleMultipleImagesUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length) {
      setFormData((prevState) => ({
        ...prevState,
        serviceImages: [...prevState.serviceImages, ...files],
      }));
    }
  };

  const removeImage = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      serviceImages: prevState.serviceImages.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { _id = "" } = getUserData()
    // Create a new FormData object
    const newFormData = new FormData();
    newFormData.append('name', formData.name);
    newFormData.append('location', formData.location);
    newFormData.append('email', formData.email);
    newFormData.append('mobile', formData.mobile);
    newFormData.append('experience', formData.experience);
    newFormData.append('companyProfile', formData.companyProfile);
    newFormData.append('selectedService', formData.selectedService);
    newFormData.append('selectedSubServices', JSON.stringify(formData.selectedSubServices));
    newFormData.append('userId', _id); // Replace with the actual user ID

    // Append the logo image and service images
    if (formData.logoImage) newFormData.append('logoImage', formData.logoImage);
    formData.serviceImages.forEach((image) => newFormData.append('serviceImages', image));

    // Start the loading state
    setLoading(true);

    try {
      // Make the API call to add the service
      const response = await createService(newFormData)
      console.log("response", response)
      // Handle success
      if (response.success) {
        showSuccess(response.message); // Show success toast
        setFormData({
          name: '',
          location: '',
          email: '',
          mobile: '',
          experience: '',
          companyProfile: '',
          selectedService: '',
          selectedSubServices: [],
          logoImage: null,
          serviceImages: [],
        });
      }
    } catch (error) {
      // Handle error
      showError(error.response?.data?.message || 'Failed to add service');
    } finally {
      setLoading(false); // End loading state
    }
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      location: '',
      email: '',
      mobile: '',
      experience: '',
      companyProfile: '',
      selectedService: '',
      selectedSubServices: [],
      logoImage: null,
      serviceImages: [],
    });
  };

  return (
    <div className="bg-[#f5f5f5] py-[160px]">
      <div className="max-w-4xl mx-auto p-6 bg-white border rounded-lg shadow-md ">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Add Service</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Name Field */}
            <div className="mb-4 ">
              <label htmlFor="name" className="block text-gray-700 font-medium mb-2">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Location Field */}
            <div className="mb-4 relative">
              <label htmlFor="location" className="block text-gray-700 font-medium mb-2">
                Location <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="location"
                name="location"
                // value={formData.location}
                value={value}
                // onChange={handleChange}
                onChange={(e) => {
                  setValue(e.target.value);
                  setFormData((prevState) => ({ ...prevState, location: e.target.value }));
                }}
                placeholder="Enter your location"
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {status === "OK" && (
                <ul className="absolute z-10 w-full border bg-white mt-1 rounded-md shadow-lg max-h-60 overflow-y-auto">
                  {data.map(({ place_id, description }) => (
                    <li key={place_id} className="p-2 cursor-pointer hover:bg-gray-200" onClick={() => handleLocationSelect(description)}>
                      {description}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Contact Details Fields */}
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="mobile" className="block text-gray-700 font-medium mb-2">
                Mobile Number <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter your mobile number"
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Select Service Dropdown */}
            <div className="mb-4 col-span-2">
              <label htmlFor="selectedService" className="block text-gray-700 font-medium mb-2">
                Select Service <span className="text-red-500">*</span>
              </label>
              <select
                id="selectedService"
                name="selectedService"
                value={formData.selectedService}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select a Service</option>
                {servicesList.map((service, index) => (
                  <option key={index} value={service}>
                    {service}
                  </option>
                ))}
              </select>
            </div>

            {/* Subcategory Selection (Appears only if "Home Services" is selected) */}
            {formData.selectedService === 'Home Services' && (
              <div className="mb-4 col-span-2">
                <label className="block text-gray-700 font-medium mb-2">
                  Select Sub-Service
                </label>
                <div className="flex flex-wrap gap-3 p-3 border border-gray-300 rounded-md">
                  {subServicesList.map((subService, index) => (
                    <div
                      key={index}
                      className={`flex items-center cursor-pointer justify-between  px-3 py-1 border rounded-md transition ${formData.selectedSubServices.includes(subService)
                        ? 'bg-green-500 text-white'
                        : 'bg-gray-100 hover:bg-gray-200'
                        }`}
                      onClick={() => handleSubServiceToggle(subService)}
                    >
                      <span className="mr-2 text-sm">{subService}</span>
                      {formData.selectedSubServices.includes(subService) ? (
                        <FaCheck className="text-white" />
                      ) : (
                        <FaPlus className="text-blue-600" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}



            {/* Logo Upload */}
            <div className="mb-4 col-span-2">
              <label className="block text-gray-700 font-medium mb-2">Upload Logo Image</label>
              <input type="file" accept="image/*" onChange={handleLogoUpload} className="w-full p-2 border rounded-md" />
              {formData.logoImage && <img src={URL.createObjectURL(formData.logoImage)} alt="Logo Preview" className="mt-2 w-32 h-32 object-cover border rounded-md" />}
            </div>

            {/* Multiple Images Upload */}
            <div className="mb-4 col-span-2">
              <label className="block text-gray-700 font-medium mb-2">Upload Pictures</label>
              <input type="file" accept="image/*" multiple onChange={handleMultipleImagesUpload} className="w-full p-2 border rounded-md" />
              <div className="flex flex-wrap gap-2 mt-2">
                {formData.serviceImages.map((image, index) => (
                  <div key={index} className="relative">
                    <img
                      src={URL.createObjectURL(image)}

                      alt="Uploaded" className="w-24 h-24 object-cover border rounded-md" />
                    <button
                      type="button"
                      onClick={() => removeImage(index)}
                      className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                    >
                      <FaTrash />
                    </button>
                  </div>
                ))}
              </div>
            </div>



            {/* Experience Field */}
            <div className="mb-4">
              <label htmlFor="experience" className="block text-gray-700 font-medium mb-2">
                Experience (in years) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                id="experience"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                placeholder="Enter years of experience"
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Company Profile Field */}
            <div className="mb-4 col-span-2">
              <label className="block text-gray-700 font-medium mb-2">Company Profile</label>
              <textarea
                name="companyProfile"
                value={formData.companyProfile}
                onChange={handleChange}
                placeholder="Provide a brief company profile"
                required
                rows="4"
                className="w-full p-3 border border-gray-300 rounded-md"
              ></textarea>
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-4">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-400 text-white py-3 px-6 rounded-md hover:bg-gray-600 transition duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition duration-200"
              disabled={loading} // Disable the submit button when loading
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddServiceForm;
